export default __webpack_public_path__ + "static/media/LegoEducation.59625a1e.webp";